import { useSnapshot } from 'valtio';
import { useReactQuery } from '@graphql/reactQuery';
import { EditedAuctionConfigPersistence, editedAuctionConfigState } from './fields/auctionConfig';
import { clearAuctionConfigErrors } from './helpers';
import { validateEditedAuctionConfigState } from './validation';

export const useEditedAuctionConfigForm = () => {
  const { fields, errors, isValid, hasPresaleMint, auctionType } = useSnapshot(
    editedAuctionConfigState,
    {
      sync: true,
    },
  );

  return {
    clearErrors: clearAuctionConfigErrors,
    errors,
    fields,
    isValid,
    validate: validateEditedAuctionConfigState,
    hasPresaleMint,
    auctionType,
  };
};

export function useEditedSaleSchedulesFromPersistence({
  contractAddress,
}: {
  contractAddress: string | undefined | null;
}) {
  const { data: persistedSaleSchedules, isInitialLoading } = useReactQuery({
    queryKey: ['edited-sale-schedules-persistence', contractAddress],
    enabled: !!contractAddress,
    queryFn() {
      if (!contractAddress) return null;

      return EditedAuctionConfigPersistence.get().then(
        data => data?.editedSaleSchedules[contractAddress] ?? null,
      );
    },
  });

  return {
    persistedSaleSchedules,
    isInitialLoading,
  };
}

export function useEditedAllowlistsFromPersistence({ releaseId }: { releaseId?: string | null }) {
  const { data: persistedAllowlists, isInitialLoading } = useReactQuery({
    queryKey: ['edited-sale-schedules-persistence', releaseId],
    enabled: !!releaseId,
    queryFn() {
      if (!releaseId) return null;

      return EditedAuctionConfigPersistence.get().then(data => data?.allowlists[releaseId] ?? null);
    },
  });

  return {
    persistedAllowlists,
    isInitialLoading,
  };
}
